function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
import { DockerImageVersionType, kernelsClient as kernelsClientSdk } from "../../../generated/kernels";
import { delay } from "../../../utils/utils";
import { listKernelVersionsResponse } from "./listKernelVersionsResponse";
var KERNEL_ID = 10;
var KERNEL_RUN_ID = 2001;
var KERNEL_VERSION_ID = 3000;
/** Stub implementation of kernelsClient. */ export var kernelsClient = _objectSpreadProps(_objectSpread({}, kernelsClientSdk), {
    kernelsService: _objectSpreadProps(_objectSpread({}, kernelsClientSdk.kernelsService), {
        cancelKernelSession: function() {
            var _ref = _asyncToGenerator(function(_req) {
                return __generator(this, function(_state) {
                    return [
                        2,
                        {}
                    ];
                });
            });
            return function(_req) {
                return _ref.apply(this, arguments);
            };
        }(),
        commitAndRun: function() {
            var _ref = _asyncToGenerator(function(_req) {
                return __generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                delay(300)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                {
                                    // On commit and run the backend resets sequence to 0.
                                    sequence: 0,
                                    kernelRunId: KERNEL_RUN_ID + 1
                                }
                            ];
                    }
                });
            });
            return function(_req) {
                return _ref.apply(this, arguments);
            };
        }(),
        createKernelSession: function() {
            var _ref = _asyncToGenerator(function(_req) {
                return __generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                delay(1000)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                {
                                    id: KERNEL_RUN_ID,
                                    resources: {
                                        storageBytes: 5 * 1024 * 1024 * 1024,
                                        memoryBytes: 16 * 1024 * 1024 * 1024,
                                        cpuCores: 4,
                                        sessionTimeoutSeconds: 9 * 60 * 60,
                                        timeSeconds: 9 * 60 * 60,
                                        idleTimeoutSeconds: 1 * 60 * 60,
                                        network: "no-external"
                                    },
                                    useNewKernelsBackend: false,
                                    showParentForkSecretWarning: false
                                }
                            ];
                    }
                });
            });
            return function(_req) {
                return _ref.apply(this, arguments);
            };
        }(),
        deleteKernel: function() {
            var _ref = _asyncToGenerator(function(_req) {
                return __generator(this, function(_state) {
                    throw new Error("Not implemented.");
                });
            });
            return function(_req) {
                return _ref.apply(this, arguments);
            };
        }(),
        getKernel: function() {
            var _ref = _asyncToGenerator(function(req) {
                return __generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                delay(100)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                {
                                    id: req.kernelId ? req.kernelId : KERNEL_ID,
                                    author: {},
                                    bestPublicScore: null,
                                    commentCount: 0,
                                    currentRunId: KERNEL_RUN_ID,
                                    forkCount: 0,
                                    forkParent: {},
                                    isLanguageTemplate: false,
                                    isPrivate: true,
                                    medal: undefined,
                                    mostRecentRunId: KERNEL_RUN_ID,
                                    pinnedDockerImageVersionId: 0,
                                    readGroupId: 0,
                                    selfLink: "",
                                    slug: "",
                                    tags: [],
                                    title: "Fake Title",
                                    topicId: 0,
                                    updatedTime: "2018-08-05T20:19:50.905Z",
                                    upvoteCount: 0,
                                    url: "willbrazil/abc-random-url",
                                    viewCount: 0,
                                    writeGroupId: 0
                                }
                            ];
                    }
                });
            });
            return function(req) {
                return _ref.apply(this, arguments);
            };
        }(),
        getKernelListDetails: function() {
            var _ref = _asyncToGenerator(function(_req) {
                return __generator(this, function(_state) {
                    return [
                        2,
                        {
                            kernels: [
                                {
                                    id: 1,
                                    scriptUrl: "will/brazil",
                                    title: "Map of Restaurants in San Francisco",
                                    dataSources: [
                                        {
                                            sourceId: 10,
                                            name: "FIFA",
                                            children: [
                                                {
                                                    id: 100,
                                                    name: "Something.csv"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    id: 2,
                                    scriptUrl: "will/brazil2",
                                    title: "Feature Extraction Scaling"
                                }
                            ],
                            totalCount: 2
                        }
                    ];
                });
            });
            return function(_req) {
                return _ref.apply(this, arguments);
            };
        }(),
        listDockerImages: function() {
            var _ref = _asyncToGenerator(function(_req) {
                return __generator(this, function(_state) {
                    return [
                        2,
                        {
                            images: [],
                            selectedVersionType: DockerImageVersionType.ORIGINAL
                        }
                    ];
                });
            });
            return function(_req) {
                return _ref.apply(this, arguments);
            };
        }(),
        listKernelIds: function() {
            var _ref = _asyncToGenerator(function(_req) {
                return __generator(this, function(_state) {
                    return [
                        2,
                        {
                            kernelIds: [
                                1
                            ]
                        }
                    ];
                });
            });
            return function(_req) {
                return _ref.apply(this, arguments);
            };
        }(),
        updateKernelDraft: function() {
            var _ref = _asyncToGenerator(function(req) {
                return __generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                delay(1000)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                {
                                    sequence: req.sequence + 1,
                                    kernelVersionId: KERNEL_VERSION_ID
                                }
                            ];
                    }
                });
            });
            return function(req) {
                return _ref.apply(this, arguments);
            };
        }(),
        listKernelVersions: function() {
            var _ref = _asyncToGenerator(function(_req) {
                return __generator(this, function(_state) {
                    return [
                        2,
                        listKernelVersionsResponse
                    ];
                });
            });
            return function(_req) {
                return _ref.apply(this, arguments);
            };
        }(),
        getAcceleratorQuotaStatistics: function() {
            var _ref = _asyncToGenerator(function(_req) {
                return __generator(this, function(_state) {
                    return [
                        2,
                        {
                            quotaRefreshTime: new Date("2023-01-01"),
                            kernelsMaxSizeInMb: 10,
                            tpuQuota: {
                                hasEverRun: false,
                                minimumTimeAllowed: {
                                    seconds: 3600 * 30,
                                    nanos: 0
                                },
                                timeReserved: {
                                    seconds: 3600 * 15,
                                    nanos: 0
                                },
                                timeUsed: {
                                    seconds: 3600 * 10,
                                    nanos: 0
                                },
                                totalTimeAllowed: {
                                    seconds: 3600 * 30,
                                    nanos: 0
                                }
                            },
                            gpuQuota: {
                                hasEverRun: false,
                                minimumTimeAllowed: {
                                    seconds: 3600 * 20,
                                    nanos: 0
                                },
                                timeReserved: {
                                    seconds: 3600 * 10,
                                    nanos: 0
                                },
                                timeUsed: {
                                    seconds: 3600 * 5,
                                    nanos: 0
                                },
                                totalTimeAllowed: {
                                    seconds: 3600 * 20,
                                    nanos: 0
                                }
                            }
                        }
                    ];
                });
            });
            return function(_req) {
                return _ref.apply(this, arguments);
            };
        }()
    })
});
